import FastMarquee from "react-fast-marquee";

const items = ["0% Commission", "Own your data", "One-time price", "Your brand. Your rules.", "Live in 7 days", "No subscriptions"];

export default function Marquee() {
  return (
    <div data-testid="editorial-marquee" className="relative border-y border-ink/10 py-10 overflow-hidden bg-white">
      <FastMarquee speed={28} gradient={false}>
        {items.concat(items).map((item, i) => (
          <span key={i} className="flex items-center">
            <span className={`font-display font-black uppercase tracking-tighter text-5xl md:text-7xl mx-8 ${i % 2 === 0 ? "text-outline" : "text-ink/85"}`}>
              {item}
            </span>
            <span className="w-3 h-3 rounded-full bg-brand mx-4 shrink-0" />
          </span>
        ))}
      </FastMarquee>
    </div>
  );
}
